/* eslint-disable no-param-reassign */
/* eslint-disable eqeqeq */
export const defaultDataSchemaContext = {
    /** 为数据赋值时使用，比如用于 Vue 可以设置为 Vue.set */
    set: (obj, key, value) => {
        if (obj != null)
            obj[key] = value;
    },
    /** 为数据删除字段时使用，比如用于 Vue 可以设置为 Vue.delete */
    delete: (obj, key) => {
        if (obj != null)
            delete obj[key];
    },
    /** 是否使用“不可变”模式？ */
    immutable: false,
};
export function makeDataSchemaContext(x) {
    return Object.assign(Object.assign({}, defaultDataSchemaContext), x);
}
